import React, { useState } from 'react';
import './Contact.css';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', organiser: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = e => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return;
    setLoading(true);
    const subject = encodeURIComponent(`[${form.organiser}] ${form.subject || 'Contact Form Submission'}`);
    const body = encodeURIComponent(
      `From: ${form.name}\nEmail: ${form.email}\nOrganiser: ${form.organiser}\nSubject: ${form.subject}\n\n${form.message}`
    );
    setTimeout(() => {
      window.location.href = `mailto:help@hivee.app?subject=${subject}&body=${body}`;
      setLoading(false);
      setSubmitted(true);
    }, 800);
  };

  return (
    <div className="contact-page">
      <div className="page-banner">
        <div className="container">
          <h1>Contact Us</h1>
          <p>We're here to help — get in touch with our team</p>
        </div>
      </div>

      <section className="contact-section">
        <div className="container contact-grid">
          <div className="contact-info">
            <div className="info-card">
              <div className="info-icon">✉️</div>
              <h3>Email Us</h3>
              <p>Send us a message directly at:</p>
              <a href="mailto:help@hivee.app" className="email-link">help@hivee.app</a>
            </div>
            <div className="info-card">
              <div className="info-icon">🌏</div>
              <h3>We're Based In</h3>
              <p>Based in Australia, HiveeClub works with venues and events across Sydney, Perth, Melbourne, Brisbane, and more.</p>
            </div>
            <div className="info-card">
              <div className="info-icon">⏰</div>
              <h3>Response Time</h3>
              <p>We typically respond within <strong>24–48 hours</strong> on business days.</p>
            </div>
            <div className="info-card">
              <div className="info-icon">🤝</div>
              <h3>Partnerships</h3>
              <p>Interested in partnering with HiveeClub? Reach out to our team at <a href="mailto:info@hivee.app" className="email-link">info@hivee.app</a></p>
            </div>
          </div>

          <div className="contact-form-wrap">
            {submitted ? (
              <div className="success-card">
                <div className="success-icon">✅</div>
                <h2>Message Sent!</h2>
                <p>Thanks for reaching out. We'll get back to you within 24–48 hours.</p>
                <button className="btn-primary" onClick={() => setSubmitted(false)}>Send Another</button>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <h2>Send Us a Message</h2>
                <p>Fill in the form below and we'll be in touch.</p>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Your Name *</label>
                    <input id="name" name="name" type="text" placeholder="John Smith" value={form.name} onChange={handleChange} required />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input id="email" name="email" type="email" placeholder="you@example.com" value={form.email} onChange={handleChange} required />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="organiser">Select Organiser</label>
                  <select id="organiser" name="organiser" value={form.organiser} onChange={handleChange}>
                    <option value="">Select an Organiser</option>
                    <option>WAO Superclub</option>
                    <option>General Enquiry</option>
                    <option>Technical Support</option>
                    <option>Partnership</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject</label>
                  <input id="subject" name="subject" type="text" placeholder="How can we help?" value={form.subject} onChange={handleChange} />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea id="message" name="message" rows={5} placeholder="Tell us more..." value={form.message} onChange={handleChange} required />
                </div>

                <button type="submit" className="btn-primary submit-btn" disabled={loading}>
                  {loading ? (
                    <><span className="spinner" /> Sending...</>
                  ) : (
                    <>Send Message →</>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
